// What this browser can do, checked before a guest is offered the join
// button. JBS#2152 is a Firefox client that retried forever with nothing on
// screen; the gate exists so that never happens here — an unsupported
// browser gets a reason, not a spinner.
export const VIDEO_CODEC = 'avc1.42E01F'; // H.264 Constrained Baseline 3.1 — covers the fixed 1280x720@30 uplink
export const AUDIO_CODEC = 'mp4a.40.2'; // AAC-LC
export const AUDIO_SAMPLE_RATE = 48_000;
export async function detectCapabilities(g = globalThis) {
    const missing = [];
    if (typeof g.WebTransport !== 'function')
        missing.push('WebTransport');
    if (typeof g.VideoEncoder !== 'function')
        missing.push('WebCodecs VideoEncoder');
    if (typeof g.VideoDecoder !== 'function')
        missing.push('WebCodecs VideoDecoder');
    if (typeof g.MediaStreamTrackProcessor !== 'function')
        missing.push('MediaStreamTrackProcessor');
    const nav = g.navigator;
    if (typeof nav?.mediaDevices?.getUserMedia !== 'function')
        missing.push('camera access (getUserMedia)');
    if (missing.length === 0) {
        const VE = g.VideoEncoder;
        const res = await VE.isConfigSupported({
            codec: VIDEO_CODEC,
            width: 1280,
            height: 720,
            bitrate: 2_000_000,
            framerate: 30,
            latencyMode: 'realtime',
            avc: { format: 'annexb' },
        }).catch(() => ({ supported: false }));
        if (!res.supported)
            missing.push('H.264 video encoding');
    }
    let aacEncode = false;
    if (typeof g.AudioEncoder === 'function' && typeof g.AudioDecoder === 'function') {
        const AE = g.AudioEncoder;
        const res = await AE.isConfigSupported({
            codec: AUDIO_CODEC,
            sampleRate: AUDIO_SAMPLE_RATE,
            numberOfChannels: 2,
            bitrate: 96_000,
        }).catch(() => ({ supported: false }));
        aacEncode = res.supported === true;
    }
    return { supported: missing.length === 0, missing, aacEncode };
}
//# sourceMappingURL=capabilities.js.map